import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event20 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "10px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    Inauguration of the Integrated Waste Management and Resource Recovery

System at Rohingya Camp 2W, Cox’s Bazar

Date: 30 September 2025
                  </h2>
<p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                      padding: "10px 0",
                    }}
                  >
                    Date: 30 September 2025
                  </p>


                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    On 30 September 2025, Md. Rezaul Maksud Jahedi, Honourable Secretary, Local Government
Division (LGD), Ministry of Local Government, Rural Development and Cooperatives
(MoLGRD&amp;C), formally inaugurated the Integrated Waste Management and Resource Recovery
System at Rohingya Camp 2W, Cox’s Bazar.
                  </p>
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    The inauguration ceremony was graced by Engr. Mir Abdus Shahid, Chief Engineer, Department
of Public Health Engineering (DPHE), and Mr. Mohammad Abdul Kaiyum, Project Director,
Emergency Multi-Sector Rohingya Crisis Response Project (EMCRP),DPHE. Project directors,
Senior officials, engineers, and development partners were also present at the event.
                  </p>
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    This state-of-the-art facility represents a major step toward sustainable sanitation and waste
management in the Rohingya camps. The system integrates faecal sludge treatment and solid
waste management through a combination of innovative technologies. The faecal sludge
treatment process includes unplanted drying beds, an Anaerobic Baffled Reactor (ABR),
constructed wetlands, and polishing ponds for effective wastewater treatment.
                  </p>
                  
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    For organic waste and dried sludge, the system incorporates a co-composting unit equipped with
a mechanical turner to produce high-quality compost. The inorganic waste fraction is managed
through a plasma gasification plant, which converts waste into syngas for electricity generation.
The electricity produced is used to power the facility itself, ensuring a self-sustaining and
energy-efficient operation.
                  </p>
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    During the visit, Dr. Abdullah Al-Muyeed, Chief Operating Officer, CWIS-FSM Support Cell,
DPHE, provided an overview of the entire system, explaining how the integrated approach
promotes circular resource recovery, reduces environmental impact, and enhances resilience
within the camp context.
                  </p>
                   
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    The inauguration marks a significant milestone in advancing climate-resilient and sustainable
waste management solutions in humanitarian settings, aligning with the Government of
Bangladesh’s commitment to improving public health and environmental protection.
                  </p>
                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news30/0.JPG`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news30/1.JPG`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "600px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news30/2.JPG`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "600px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news30/3.JPG`}
                          alt="thumb"
                        />
                      </div>
                    </Col>

                  </Row>


                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event20;
